import 'client-only';

import { heicTo } from 'heic-to';

import { JPEG_IMAGE_FORMAT } from '@/utils/images/types';

const normalizeFileName = (name: string): string =>
  name.replace(/\.(heic|heif)$/i, '.jpg');

// @ts-expect-error - TODO: broken by noImplicitAny
export const heicConverter = async (uploadedImage) => {
  try {
    const blob = await heicTo({
      blob: uploadedImage,
      type: JPEG_IMAGE_FORMAT,
      quality: 0.82,
    });

    const convertedFile = new File(
      [blob],
      normalizeFileName(uploadedImage.name),
      { type: JPEG_IMAGE_FORMAT },
    );

    console.log(
      '[HEIC Converter] Converted file size (bytes):',
      convertedFile.size,
    );

    return convertedFile;
  } catch (error) {
    console.error('[HEIC Converter] Failed to convert file', error);
    throw error;
  }
};
